import Reflux from 'reflux';
import ShowData from 'shared/data/Show';
import ItemSetData from 'shared/data/ItemSet';

let async = { asyncResult: true };

let PublishGlobalElementsActions = Reflux.createActions({
  populate: {},
  populateForShowRow: {},
  toggleItemSelection: {},
  toggleAllItemSelection: {},
  searchItems: {},
  clearSearch: {},
  clearSelection: {},
  getGlobalElementShowItems: async,
  getGlobalElementShowItemsForShowRow: async,
  publishChanges: async,
  publishChangesEverywhere: async,
});

PublishGlobalElementsActions.getGlobalElementShowItems.listenAndPromise(
  ShowData.getByGlobalElement,
);

PublishGlobalElementsActions.getGlobalElementShowItemsForShowRow.listenAndPromise(
  ShowData.getByGlobalElement,
);

PublishGlobalElementsActions.publishChanges.listenAndPromise(
  ItemSetData.publishGlobalElementChanges,
);

PublishGlobalElementsActions.publishChangesEverywhere.listenAndPromise(
  ItemSetData.publishShowRowChangesEverywhereForGlobalElement,
);

export default PublishGlobalElementsActions;
